module.exports = __webpack_public_path__ + "img/exposure-graph-no-data.e9337210.svg";